var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-svg-container"},[(_vm.hasBackground)?_c('div',{staticClass:"banner-svg-container__back"}):_vm._e(),_vm._v(" "),_c('BaseImg',{attrs:{"alt":"banner","src":_vm.img,"sizes":_vm.imgSizes,"preload":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }